import { useState } from 'react';
import { Layout, Modal } from 'antd';
import HeaderBar from '../../../Layout/HeaderBar';
import FooterBar from '../../../Layout/FooterBar';

import { useTranslation } from 'react-i18next';
import TableList from '../Table';
import InventoryNav from '../InventoryNav';
import { InventoryContextForType, InventoryType } from '../../../modules/inventory/types';
import EditForm from './EditForm';
import AddForm from './AddForm';
import { Badge } from 'components/ui/badge';
import keyBy from 'lodash.keyby';

const { Content } = Layout;

interface IHomeViewProps {
  gps: InventoryContextForType<InventoryType.GPS>[];
  inventoryTagsMap: { [id: string]: { id: string; title: string } };
  simcards: InventoryContextForType<InventoryType.SIM_CARDS>[];
}

function InventoryGPSView({ gps, simcards, inventoryTagsMap }: IHomeViewProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<string | null>(null);
  const onClose = () => setVisible(null);
  const simcardMap = keyBy(simcards, 'id');
  return (
    <>
      <Layout>
        <HeaderBar />
        <Content className="min-w-0 px-4 py-6 md:px-6">
          <div className="mx-auto max-w-[1600px] space-y-5">
            <InventoryNav />
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="flex items-center gap-3">
                  <h1 className="m-0 text-2xl font-semibold tracking-tight">
                    {t('sidenavInventory.gps')}
                  </h1>
                  <Badge variant="secondary">{gps.length}</Badge>
                </div>
                <p className="mb-0 mt-1 text-sm text-muted-foreground">
                  {t('Søg, find og administrer dit udstyr.')}
                </p>
              </div>
              <AddForm simcards={simcards} inventoryTagsMap={inventoryTagsMap} />
            </div>
            <TableList
              type={InventoryType.GPS}
              data={gps}
              setVisible={setVisible}
              simcardMap={simcardMap}
            />
          </div>
        </Content>
        <FooterBar />
      </Layout>
      <Modal title="Ret GPS" open={!!visible} confirmLoading={false} onCancel={onClose} footer={[]}>
        {visible && (
          <EditForm
            key={visible}
            id={visible}
            onClose={onClose}
            inventoryTagsMap={inventoryTagsMap}
            simcards={simcards}
          />
        )}
      </Modal>
    </>
  );
}

export default InventoryGPSView;
